module.exports = __webpack_public_path__ + "static/media/caro_img_2.deef85b1.webp";